import { serviceMaker, methods, api } from "./index.js";
export const getAccounting = () =>
  serviceMaker(
    `/provisioning/provisioningactions?limit=14&offset=0`,
    methods.GET,
    api.NGB
  );
export const updateProvisioningOrder = (id, data) =>
  serviceMaker(
    `/provisioning/updateprovisiondetails/${id}`,
    methods.PUT,
    api.NGB,
    data
  );
export const geteventActionsListData = () =>
  serviceMaker(`/eventactions?limit=14&offset=0`, methods.GET, api.NGB);
export const getEventActionsByStatus = (source) =>
  serviceMaker(
    `/eventactions?limit=14&offset=0&source=${source}`,
    methods.GET,
    api.NGB
  );
export const getChartOfAccounts = () =>
  serviceMaker(`/glaccounts`, methods.GET, api.NGB);
export const accountTemplateData = () =>
  serviceMaker(`/glaccounts/template?type=0`, methods.GET, api.NGB);
export const accountTemplateDataById = (id) =>
  serviceMaker(`/glaccounts/${id}?template=true`, methods.GET, api.NGB);
export const createGLAccount = (data) =>
  serviceMaker(`/glaccounts`, methods.POST, api.NGB, data);
export const updateGLAccount = (id, data) =>
  serviceMaker(`/glaccounts/${id}`, methods.PUT, api.NGB, data);
export const deleteGLAccount = (id) =>
  serviceMaker(`/glaccounts/${id}`, methods.DELETE, api.NGB);

export const getAccountingRulesList = () =>
  serviceMaker(`/accountingrules`, methods.GET, api.NGB);
export const getAccountingRulesTemplate = () =>
  serviceMaker(`/accountingrules/template`, methods.GET, api.NGB);
export const getAccountingRulesById = (id) =>
  serviceMaker(`/accountingrules/${id}`, methods.GET, api.NGB);
export const getRulesTemplateById = (id) =>
  serviceMaker(`/accountingrules/${id}?template=true`, methods.GET, api.NGB);
export const deleteRule = (id) =>
  serviceMaker(`/accountingrules/${id}`, methods.DELETE, api.NGB);
export const createAccountingRule = (data) =>
  serviceMaker(`/accountingrules`, methods.POST, api.NGB, data);
export const editAccountingRule = (id, data) =>
  serviceMaker(`/accountingrules/${id}`, methods.PUT, api.NGB, data);

export const getClosingEntriesList = () =>
  serviceMaker(`/glclosures`, methods.GET, api.NGB);
export const filterClosureListByOffice = (id) =>
  serviceMaker(`/glclosures?officeId=${id}`, methods.GET, api.NGB);
export const getOfficesList = () =>
  serviceMaker(`/offices`, methods.GET, api.NGB);
export const createClosure = (data) =>
  serviceMaker(`/glclosures`, methods.POST, api.NGB, data);
export const updateClosure = (id, data) =>
  serviceMaker(`/glclosures/${id}`, methods.PUT, api.NGB, data);
export const deleteClosure = (id) =>
  serviceMaker(`/glclosures/${id}`, methods.DELETE, api.NGB);
export const getClosureDataById = (id) =>
  serviceMaker(`/glclosures/${id}`, methods.GET, api.NGB);
export const getAccountingRules = () =>
  serviceMaker(`/accountingrules?associations=all`, methods.GET, api.NGB);
export const getCurrencyData = () =>
  serviceMaker(
    `/currencies?fields=selectedCurrencyOptions`,
    methods.GET,
    api.NGB
  );
export const getPaymentTypes = () =>
  serviceMaker(`/paymenttypes`, methods.GET, api.NGB);
export const addFrequentPostings = (data) =>
  serviceMaker(`/journalentries`, methods.POST, api.NGB, data);

export const getAllowedAccounts = () =>
  serviceMaker(
    `/glaccounts?disabled=false&manualEntriesAllowed=true&usage=1`,
    methods.GET,
    api.NGB
  );

export const getFinancialActivityAccounts = () =>
  serviceMaker(`/financialactivityaccounts`, methods.GET, api.NGB);
export const viewFinancialActivityDataById = (id) =>
  serviceMaker(`/financialactivityaccounts/${id}`, methods.GET, api.NGB);
export const financialActivityTemplate = () =>
  serviceMaker(`/financialactivityaccounts/template`, methods.GET, api.NGB);
export const addFinancialActivityMapping = (data) =>
  serviceMaker(`/financialactivityaccounts`, methods.POST, api.NGB, data);
export const updateFinancialActivityMapping = (id, data) =>
  serviceMaker(`/financialactivityaccounts/${id}`, methods.PUT, api.NGB, data);
export const deletefinancialActivityMapping = (id) =>
  serviceMaker(`/financialactivityaccounts/${id}`, methods.DELETE, api.NGB);

export const filterJournalEntriesList = (options = {}) => {
  const baseURL = `/journalentries?dateFormat=dd-MMMM-yyyy&limit=14&locale=en&offset=0`;
  const queryParams = new URLSearchParams(options);
  ["fromDate", "toDate"].forEach((param) => {
    if (queryParams.has(param)) {
      const formattedDate = queryParams.get(param).replace(/\s+/g, "-");
      queryParams.set(param, formattedDate);
    }
  });
  return serviceMaker(`${baseURL}&${queryParams.toString()}`, methods.GET, api.NGB);
};
export const transactionDetails = (id) =>
  serviceMaker(`/journalentries?transactionDetails=true&transactionId=${id}`, methods.GET, api.NGB);
export const reverseTransaction = (data) =>
  serviceMaker(`/journalentries/${data.transactionId}?command=reverse`, methods.POST, api.NGB, data);

export const getOpeningBalances = (code, id) =>
  serviceMaker(`/journalentries/openingbalance?currencyCode=${code}&officeId=${id}`, methods.GET, api.NGB);
export const saveOpeningBalances = (data) =>
  serviceMaker(`/journalentries?command=defineOpeningBalance`, methods.POST, api.NGB, data);

